import styled from 'styled-components';

export default styled.div`
  height: 100%;
  overflow: hidden;
  form {
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 60px;
    .from-content {
      height: 100%;
      flex-shrink: 1;
      overflow: auto;
      display: flex;
      gap: 48px;
      overflow: auto;
      .left-content {
        flex: 1;
        flex-shrink: 1;
        display: flex;
        flex-direction: column;
        gap: 24px;
      }
      .center-content {
        flex: 1;
        flex-shrink: 1;
        display: flex;
        flex-direction: column;
        gap: 6px;
        .prize-table-wrap {
          .prize-table-head {
            display: flex;
            height: 48px;
            line-height: 48px;
            background-color: #f9f9f9;
            .th {
              font-weight: 400;
              font-size: 16px;
              line-height: 48px;
              color: #111111;
              text-align: center;
            }
            .th-1 {
              width: 88px;
              flex-shrink: 0;
            }
            .th-2 {
              width: 100%;
              flex-shrink: 1;
            }
          }
          .prize-table-body {
            display: flex;
            height: 56px;
            line-height: 56px;
            .td {
              font-weight: 400;
              font-size: 14px;
              line-height: 56px;
              color: #333333;
            }
            .td-1 {
              width: 88px;
              flex-shrink: 0;
              padding: 0 12px;
              text-align: center;
            }
            .td-2 {
              width: 100%;
              flex-shrink: 1;
              padding: 0 12px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }
      .right-content {
        flex: 1;
        flex-shrink: 1;
        display: flex;
        flex-direction: column;
        gap: 24px;
        overflow: hidden;
        padding-right: 10px;
      }

      .MuiCheckbox-root {
        padding: 0;
      }
    }
  }
  .img-limit-style {
    margin-top: 8px;
    height: 17px;
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    color: #999999;
  }
`;
